import { render, staticRenderFns } from "./events.vue?vue&type=template&id=2a3216fa&scoped=true&"
import script from "./events.vue?vue&type=script&lang=js&"
export * from "./events.vue?vue&type=script&lang=js&"
import style0 from "./feedback.css?vue&type=style&index=0&id=2a3216fa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a3216fa",
  null
  
)

export default component.exports